import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Navbar, TestSetLoader } from '../../../Components'
import { ADMIN_API, TestTypes, USER_API, RESOURCES_API, ClassOptions } from '../../../functions'
import { useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import './index.css';
import { BiArrowBack } from 'react-icons/bi';
import { MdOutlineCloudDone } from 'react-icons/md';
import Swal from 'sweetalert2';
import { useRef } from 'react';
import lottie from 'lottie-web';


const TestComponent = () => {
    const navigate = useNavigate();
    const [testInfo, setTestInfo] = useState({
        TestNumber: '',
        TestName: '',
        TestClass: '',
        TestDuration: '',
        TestType: '',
        TestDelay: '',
        showAnalysis: false,
    });
    const [initialTest, setInitialTest] = useState({});
    const [toEdit, setToEdit] = useState({
        QuestionId: '',
        Question: '',
        QuesionImg: '',
        Options: [],
        IntegerAnswer: '',
    });

    const [QuestionSet, setQuestionSet] = useState([]);
    const [ifScheduling, setIfScheduling] = useState(false);
    const [ifDelay, setIfDelay] = useState(false);
    const [ifSettingTest, setIfSettingTest] = useState(false);
    const [edtInfo, setEdtInfo] = useState(false);
    const [ifLoading, setIfLoading] = useState(true);
    const [current, setCurrent] = useState(0);
    const id = useParams().id;

    const extractName = (name) => {
        let newName = name.split('_')[1];
        return newName;
    }

    const QuestionsLoader = async () => {
        try {
            const res = await axios.get(`${ADMIN_API}/getAllTest/${id}`);
            const test = res.data.foundTest.TestInfo;
            const questions = res.data.foundTest.QuestionSet;
            let testInfo = {
                TestNumber: test.TestNumber,
                TestName: extractName(test.TestNumber),
                TestClass: test.TestClass,
                TestDuration: test.TestDuration,
                TestDate: test.TestDate ? test.TestDate : '',
                TestType: test.TestType,
                TestDelay: test.TestDelay ? test.TestDelay : '',
                showAnalysis: test.showAnalysis,
            }
            if (test.TestDate) {
                setIfScheduling(true);
            }
            if (test.TestDelay) {
                setIfDelay(true);
            }

            setTestInfo(testInfo);
            const data = res.data.foundTest.QuestionSet;
            setQuestionSet(data);
            setInitialTest(data);

        } catch (error) {
            console.log(error)
        }
        finally {
            setIfLoading(false);
        }
    }
    const checkUser = async () => {
        const user = Cookies.get('user');
        if (user) {
            try {
                let res = await axios.get(`${USER_API}/getData/${user}`);
                if (res.status === 200) {
                    if (!res.data.ifAdmin) {
                        navigate('/login');
                    }
                    else {
                        QuestionsLoader();
                    }
                }
                else {
                    Cookies.remove('user');
                    navigate('/login');
                }
            }
            catch (err) {
                navigate('/login');
            }
        }
        else {
            navigate('/login');
        }
    }

    useEffect(() => {
        checkUser();
    }, [])

    const onChangeHandler = (e) => {
        e.preventDefault();
        let newQuestionSet = QuestionSet;
        newQuestionSet.forEach((question) => {
            let Obj = `${e.target.name}${question.QuestionId}`
            if (Obj === e.target.id) {
                question[e.target.name] = e.target.value;
            }
        })
        setQuestionSet(newQuestionSet);
    };

    const onOptionChangeHandler = (e) => {
        e.preventDefault();
        let newQuestionSet = QuestionSet;
        newQuestionSet.forEach((question) => {
            if (question.QuestionId === parseInt(e.target.name)) {
                question.Options.forEach((option) => {
                    if (option.OptionId === parseInt(e.target.id)) {
                        option.Option = e.target.value;
                    }
                })
            }
        })
        // console.log(newQuestionSet);
        setQuestionSet(newQuestionSet);
    }

    const onIntegerAnswerChangeHandler = (e) => {
        e.preventDefault();
        let newQuestionSet = QuestionSet;
        newQuestionSet.forEach((question) => {
            if (question.QuestionId == e.target.id) {
                question.IntegerAnswer = e.target.value;
            }
        })
        setQuestionSet(newQuestionSet);
    }


    const updateTest = () => {
        PostToAPI();

    }

    const MultiSelect = ({ Curquestion }) => {

        const MultiOptions = [
            { OptionId: 1, Option: "", IsAnswer: false },
            { OptionId: 2, Option: "", IsAnswer: false },
            { OptionId: 3, Option: "", IsAnswer: false },
            { OptionId: 4, Option: "", IsAnswer: false },
        ]
        const handleMultiChange = (e) => {
            let newQuestionSet = [...QuestionSet];
            newQuestionSet.forEach((question) => {
                if (question.QuestionId === parseInt(e.target.name)) {
                    question.Options.forEach((option) => {
                        if (option.OptionId === parseInt(e.target.id)) {
                            option.IsAnswer = e.target.checked;
                        }
                    })
                }
            })
            setQuestionSet(newQuestionSet);
        }
        return (
            <div className='flex flex-col p-2'>
                <label htmlFor="Answer" className="block m-2 text-sm font-medium leading-6 text-gray-900">
                    More than One Correct Answer
                </label>
                <div className="flex flex-col">
                    {MultiOptions.map((option) => (
                        <div className="flex items-start">
                            <div className="flex items-center h-5">
                                <input
                                    id={option.OptionId}
                                    name={Curquestion.QuestionId}
                                    checked={Curquestion.Options[option.OptionId - 1].IsAnswer}
                                    type="checkbox"
                                    className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                    onChange={(e) => {
                                        e.preventDefault();
                                        handleMultiChange(e);
                                    }}
                                />
                                <label htmlFor={option.OptionId} className="ml-3 block text-sm font-medium text-gray-700">
                                    Option {option.OptionId}
                                </label>
                            </div>
                        </div>
                    )
                    )}
                </div>
            </div>
        );
    };


    const addFile = async (event) => {
        const imageFile = event.target.files[0];
        try {
            let newQuestionSet = QuestionSet;
            newQuestionSet.forEach((question) => {
                let Obj = `${event.target.name}${question.QuestionId}`
                if (Obj === event.target.id) {
                    question.QuestionImg = imageFile;
                }
            }
            )
            setQuestionSet(newQuestionSet);
        }
        catch (error) {
            console.log(error);
        }
    }

    const SingleChoiceOptions = ({ Curquestion }) => {



        const types = [
            { OptionId: 1, Option: "", IsAnswer: false },
            { OptionId: 2, Option: "", IsAnswer: false },
            { OptionId: 3, Option: "", IsAnswer: false },
            { OptionId: 4, Option: "", IsAnswer: false },
        ]

        const handleTypeChange = (e) => {
            let newQuestionSet = [...QuestionSet];
            newQuestionSet.forEach((question) => {
                if (question.QuestionId === Curquestion.QuestionId) {
                    question.Options.forEach((option) => {
                        if (option.OptionId === parseInt(e.target.id)) {
                            option.IsAnswer = true;
                        }
                        else {
                            option.IsAnswer = false;
                        }
                    }
                    )
                }
            })
            setQuestionSet(newQuestionSet);
        }


        return (
            <div className=' p-2'>
                <label htmlFor="Answer" className="block m-2 text-sm font-medium leading-6 text-gray-900 ">
                    Correct Answer
                </label>
                {types.map((option) => (
                    <div key={option.id} className="flex items-center">
                        <input
                            id={option.OptionId}
                            name={option.OptionId}
                            type="radio"
                            checked={Curquestion.Options[option.OptionId - 1].IsAnswer}
                            onChange={(e) => {
                                e.preventDefault();
                                handleTypeChange(e);
                            }}
                            className="focus:ring-indigo-500  h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        <label htmlFor={option.OptionId} className="ml-3 block text-sm font-medium text-gray-700 ">
                            <div
                                className={`${Curquestion.Options[option.OptionId - 1].IsAnswer ? 'text-green-900' : 'text-red-600'}`}
                            >
                                Option {option.OptionId}
                            </div>
                        </label>
                    </div>
                ))}
            </div >
        )
    }

    const SelectQuestionChoice = ({ Curquestion }) => {
        const types = [
            { id: 1, title: 'Single Correct Option' },
            { id: 2, title: 'Multiple Correct Option' },
            { id: 3, title: 'Integer Type Answer' },
        ]

        // const [choosenType, setChoosenType] = useState("Select from options given below");

        const handleTypeChange = (e) => {
            let newQuestionSet = [...QuestionSet];
            newQuestionSet.forEach((question) => {
                if (question.QuestionId === Curquestion.QuestionId) {
                    question.QuestionType = e.target.value;
                }
            })
            setQuestionSet(newQuestionSet);

        }

        return (
            <div>
                <label htmlFor="Ques_type" className="block m-2 text-sm font-medium leading-6 text-gray-900">
                    Select Question Type
                </label>
                <select
                    id="Ques_type"
                    name="Ques_type"
                    autoComplete="Ques_type"
                    value={Curquestion.QuestionType}
                    onChange={(e) => {
                        e.preventDefault();
                        handleTypeChange(e);
                    }}
                    className={`block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
                >
                    {types.map((option) => (
                        <option key={option.id}>{option.title}</option>
                    ))}
                </select>
            </div >
        )
    }

    const PostToAPI = async () => {

        let testtypes = TestTypes();
        try {
            let newTestInfo = {
                ...testInfo,
                TestDelay: (ifDelay ? testInfo.TestDelay : ''),
                TestDate: (ifScheduling ? testInfo.TestDate : ''),
                TestType: (ifDelay ? testtypes[1].name : testtypes[2].name)
            }

            for (let i = 0; i < QuestionSet.length; i++) {

                const formData = new FormData();
                formData.append("TestInfo", JSON.stringify(newTestInfo));
                formData.append("QuestionSet", JSON.stringify(QuestionSet[i]));
                if (QuestionSet[i].QuestionImg === null) {
                    formData.append(`QuestionImg`, null);
                }
                else {
                    formData.append(`QuestionImg`, QuestionSet[i].QuestionImg);
                }
                // console.log(QuestionSet[i]);

                let resp = await axios.post(`${ADMIN_API}/setTest`,
                    formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
                );
                setIfSettingTest(true);
                setCurrent(i + 1);

            }

            setIfSettingTest(false);
            Swal.fire({
                icon: 'success',
                title: 'Test Updated',
                text: 'Test has been updated successfully',
                showConfirmButton: false,
                timer: 1500
            }).then(() => {
                navigate('/Admin/AllTests')
            })
        }
        catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
                footer: `<p>${err}</p>`
            })
        }


    }


    const handleAddQuestion = () => {
        let newLength = QuestionSet.length + 1;

        setQuestionSet([...QuestionSet, {
            QuestionId: newLength,
            QuestionType: 'Single Correct Option',
            Question: '',
            QuestionImg: '',
            Options: [
                { OptionId: 1, Option: "", IsAnswer: false },
                { OptionId: 2, Option: "", IsAnswer: false },
                { OptionId: 3, Option: "", IsAnswer: false },
                { OptionId: 4, Option: "", IsAnswer: false },
            ],
            IntegerAnswer: '',
        }]);
        setToEdit({
            QuestionId: newLength,
            QuestionType: 'Single Correct Option',
            Question: '',
            QuestionImg: '',
            Options: [
                { OptionId: 1, Option: "", IsAnswer: false },
                { OptionId: 2, Option: "", IsAnswer: false },
                { OptionId: 3, Option: "", IsAnswer: false },
                { OptionId: 4, Option: "", IsAnswer: false },
            ],
            IntegerAnswer: '',
        });
    }



    const CreateOptions = ({ question }) => {
        const FourOptions = [];
        for (let i = 1; i <= 4; i++) {
            FourOptions.push(
                <QuestionInput
                    CTA={`Option ${i}`}
                    name={question.QuestionId}
                    id={i}
                    type="text"
                    currentValue={question.Options[i - 1].Option}
                    Callback={onOptionChangeHandler}
                    disabled={toEdit.QuestionId !== question.QuestionId}
                />
            )
        }
        return FourOptions;
    }


    const handleQuestionDeletion = async (question1) => {
        let newQuestionSet = QuestionSet.filter((question) => {
            return question.QuestionId !== question1.QuestionId;
        })
        setQuestionSet(newQuestionSet);

        try {
            let resp = await axios.post(`${ADMIN_API}/setTest/${question1.QuestionId}`, {
                TestNumber: testInfo.TestNumber,
            });

        }
        catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
                footer: `<p>${err}</p>`
            })
        }

    }

    const ref = useRef(null);

    const Loader = () => {
        useEffect(() => {
            const Animator = lottie.loadAnimation({
                container: ref.current,
                animationData: require('../../../Components/Animations/LoadingBarsRotation.json'),
                renderer: 'svg',
                loop: true,
                autoplay: true,

            });
            return () => Animator.destroy();
        }, [])
        return (
            <div className='flex flex-col justify-center items-center h-screen'>
                <div className='text-2xl font-extrabold m-3'>
                    Loading Test
                </div>
                <div className='w-1/2' ref={ref} ></div>
            </div>
        )
    }

    const removeFile = (question) => {
        setToEdit({ ...toEdit, QuestionImg: null });
        let newQuestionSet = QuestionSet.map((q) => {
            if (q.QuestionId === question.QuestionId) {
                return { ...q, QuestionImg: null }
            }
            else {
                return q;
            }
        }
        )
        setQuestionSet(newQuestionSet);
    }

    const optionsClass = ClassOptions();

    return (
        <>
            {ifLoading ? (<Loader />) : (
                <form className='p-1' encType="multipart/form-data">
                    <div className="flex flex-col">
                        <div className="flex flex-col">
                            <TestInfoInput
                                CTA="Test Name"
                                name="TestName"
                                type="text"
                                currentValue={testInfo.TestName}
                                Callback={setTestInfo}
                                DB={testInfo}
                                disabled={!edtInfo}
                            />
                            <div>
                                <label htmlFor="TestClass" className="block m-2 text-sm font-medium leading-6 text-gray-900">
                                    Test Class
                                </label>
                                <select
                                    id="Testclass"
                                    name="Testclass"
                                    value={testInfo.TestClass}
                                    onChange={(e) => {
                                        setTestInfo({ ...testInfo, TestClass: e.target.value });
                                    }}
                                    disabled={!edtInfo}
                                    className="block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                                >
                                    {optionsClass.map((option) => (
                                        <option
                                            key={option.id}
                                        >
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <TestInfoInput
                                CTA="Test Duration (in minutes)"
                                name="TestDuration"
                                type="number"
                                currentValue={testInfo.TestDuration}
                                Callback={setTestInfo}
                                DB={testInfo}
                                disabled={!edtInfo}
                            />
                            <div className='flex align-middle m-3'>
                                <input
                                    type="checkbox"
                                    id="showAnalysis"
                                    name="showAnalysis"
                                    checked={testInfo.showAnalysis}
                                    onChange={(e) => {
                                        setTestInfo({ ...testInfo, showAnalysis: e.target.checked })
                                    }}
                                    disabled={!edtInfo}
                                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                />
                                <label htmlFor="showAnalysis" className="ml-2 block text-sm font-medium text-gray-900">
                                    Allow student to view test analysis after submission
                                </label>
                            </div>

                            {ifScheduling && (
                                <TestInfoInput
                                    CTA="Date of Test"
                                    name="TestDate"
                                    type="datetime-local"
                                    currentValue={testInfo.TestDate}
                                    Callback={setTestInfo}
                                    DB={testInfo}
                                    disabled={!edtInfo}
                                />
                            )}
                            {(ifScheduling) ? (
                                <div className='p-4'>
                                    <Button
                                        CTA="Unschedule this Test"
                                        Callback={setIfScheduling}
                                        Value={false}
                                        color="red"
                                        disabled={!edtInfo}
                                    />

                                </div>
                            ) : (
                                <div className='p-4'>
                                    <Button
                                        CTA="Schedule this Test"
                                        Callback={setIfScheduling}
                                        Value={true}
                                        color="indigo"
                                        disabled={!edtInfo}
                                    />
                                </div>
                            )}

                            {ifDelay ? (
                                <div>
                                    <TestInfoInput
                                        CTA=" Test result Date"
                                        name="TestDelay"
                                        type="datetime-local"
                                        currentValue={testInfo.TestDelay}
                                        Callback={setTestInfo}
                                        DB={testInfo}
                                        disabled={!edtInfo}
                                    />
                                    <div className='p-4'>
                                        <Button
                                            CTA="Cancel Delay Result Test"
                                            Callback={setIfDelay}
                                            Value={false}
                                            color="red"
                                        />
                                    </div>

                                </div>
                            ) : (
                                <div className='p-4'>
                                    <Button
                                        CTA="Set to Delay Result Test"
                                        Callback={setIfDelay}
                                        Value={true}
                                        color="indigo"
                                    />
                                </div>
                            )}


                            <div className='p-4'>
                                {edtInfo ? (
                                    <Button
                                        CTA="Save Test Info"
                                        Callback={setEdtInfo}
                                        Value={!edtInfo}
                                        color="green"
                                    />
                                ) : (
                                    <Button
                                        CTA="Edit Test Info"
                                        Callback={setEdtInfo}
                                        Value={!edtInfo}
                                        color="indigo"
                                    />
                                )}

                            </div>

                        </div>
                    </div>


                    <div>
                        <div className='text-2xl font-extrabold m-3'>
                            Question List
                        </div>
                    </div>

                    {QuestionSet.map((question) => (

                        <div key={question.QuestionId} className='border border-b-4 m-1 p-1 '>
                            <div className='text-xl'>
                                Question {question.QuestionId}
                            </div>
                            <QuestionInput
                                CTA="Question"
                                name="Question"
                                id={`Question${question.QuestionId}`}
                                type="text"
                                currentValue={question.Question}
                                Callback={onChangeHandler}
                                disabled={toEdit.QuestionId !== question.QuestionId}
                            />

                            <QuestionInput
                                CTA="Question Image"
                                name="QuestionImg"
                                id={`QuestionImg${question.QuestionId}`}
                                type="file"
                                currentValue={question.QuestionImg}
                                Callback={addFile}
                                disabled={toEdit.QuestionId !== question.QuestionId}
                            />

                            <div>
                                {/* if image uploaded on frontend */}
                                {((question.QuestionImg !== "" && question.QuestionImg !== null) && typeof question.QuestionImg === "object") ? (

                                    <div
                                        onDrag={(e) => {
                                            e.preventDefault();
                                        }}
                                        className='border border-blue-gray-500 p-2 flex flex-col justify-center align-middle m-3'
                                    >
                                        <p>Selected Image</p>
                                        <img src={
                                            URL.createObjectURL(question.QuestionImg)
                                        }
                                            key={question.QuestionId}
                                            alt={`Question ${question.QuestionId} Img`}
                                            className="w-[300px] my-3"
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }
                                            }
                                        />
                                        {/* remove image option */}
                                        <div className='flex justify-center'>
                                            <Button
                                                CTA="Remove Image"
                                                Callback={removeFile}
                                                Value={question}
                                                color="red"
                                            />
                                        </div>
                                    </div>
                                ) : (null)}
                                {/* if image uploaded on backend */}
                                {((question.QuestionImg !== "" && question.QuestionImg !== null) && typeof question.QuestionImg === "string") ? (
                                    <div
                                        onDrag={(e) => {
                                            e.preventDefault();
                                        }}
                                        className='border border-blue-gray-500 p-2 flex flex-col justify-center align-middle m-3'
                                    >
                                        <p>Selected Image</p>
                                        <img src={
                                            `${RESOURCES_API}${question.QuestionImg}`
                                        }
                                            key={question.QuestionId}
                                            alt={`Question ${question.QuestionId} Img`}
                                            className="w-[300px] my-3"
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }
                                            }
                                        />
                                        <div className='flex justify-center'>
                                            <Button
                                                CTA="Remove Image"
                                                Callback={removeFile}
                                                Value={question}
                                                color="red"
                                            />
                                        </div>
                                    </div>
                                ) : (null)}
                            </div>

                            <SelectQuestionChoice
                                Curquestion={question}
                            />

                            {

                                question.QuestionType === 'Integer Type Answer' ? (
                                    <QuestionInput
                                        CTA="Answer"
                                        name="Answer"
                                        id={question.QuestionId}
                                        type="text"
                                        currentValue={question.IntegerAnswer}
                                        Callback={onIntegerAnswerChangeHandler}
                                        disabled={toEdit.QuestionId !== question.QuestionId}
                                        specialCSS="block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                                    />
                                ) : (
                                    <div>
                                        {CreateOptions({ question })}
                                        {question.QuestionType === 'Multiple Correct Option' ? (
                                            <MultiSelect
                                                Curquestion={question}
                                            />
                                        ) : (
                                            <SingleChoiceOptions
                                                Curquestion={question}
                                            />
                                        )}
                                    </div>
                                )
                            }

                            <div className='flex'>
                                <div className='m-4 '>
                                    {toEdit.QuestionId !== question.QuestionId ? (
                                        <Button
                                            CTA="Edit"
                                            Callback={setToEdit}
                                            Value={question}
                                            color="indigo"
                                        />
                                    ) : (
                                        <Button
                                            CTA="Save"
                                            Callback={setToEdit}
                                            Value={{}}
                                            color="green"
                                        />
                                    )}
                                </div>
                                <div className='m-4'>
                                    <Button
                                        CTA="Delete"
                                        Callback={handleQuestionDeletion}
                                        Value={question}
                                        color="red"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                    <Button
                        CTA="Add Question"
                        Callback={handleAddQuestion}
                        Value=""
                        color="indigo"
                        specialCSS="bg-indigo-400 flex hover:bg-indigo-500 gap-3 text-white font-bold p-4 rounded m-16"
                    />

                    <div className='m-4'>
                        <button
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                updateTest();
                            }}
                            className="px-2 py-2 border space-x-3 flex flex-row text-base font-medium rounded-md shadow-sm text-white bg-indigo-500 hover:bg-indigo-700 fixed bottom-1 right-1 sm:bottom-4 sm:right-4"
                        >
                            <MdOutlineCloudDone className='scale-150 m-2 text-white' />
                            <span className='sm:inline-block hidden'>Update and Save Test</span>
                        </button>
                    </div>
                    <div className='m-4'>
                        <button
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/Admin/AllTests`)
                            }}
                            className='px-2 py-2 border space-x-3 flex flex-row text-base font-medium rounded-md shadow-sm text-white bg-red-500 hover:bg-red-700 fixed bottom-1 left-1 sm:bottom-4 sm:left-4'
                        >
                            <BiArrowBack className='scale-150 m-2' />
                            <span className='sm:inline-block hidden'>Go Back</span>
                        </button>
                    </div>

                    <div className='m-2 mb-5'>
                        {ifSettingTest ? (<TestSetLoader total={QuestionSet.length} current={current} />) : (null)}
                    </div>
                </form>
            )}
        </>
    )
}


const TestInfoInput = ({ CTA = "Input", name, type = "text", currentValue = "", Callback, DB, disabled = "false" }) => {

    return (
        <div>
            <label htmlFor={name} className="block m-2 text-sm font-medium leading-6 text-gray-900">
                {CTA}
            </label>
            <input
                type={type}
                name={name}
                id={name}
                autoComplete={name}
                value={currentValue}
                onChange={(e) => {
                    e.preventDefault();
                    Callback({ ...DB, [e.target.name]: e.target.value });
                }}
                disabled={disabled}
                className="block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
            />
        </div>
    )
}

const Button = ({ CTA = "Button", Callback, Value, color = "blue", disabled = false, specialCSS = null }) => {
    let normalCSS = `inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${color}-600 hover:bg-${color}-700`
    if (specialCSS) {
        normalCSS = specialCSS;
    }
    return (
        <button
            type="button"
            onClick={(e) => {
                e.preventDefault();
                Callback(Value);
            }}
            disabled={disabled}
            className={normalCSS}
        >
            {CTA}
        </button>
    )

}

const QuestionInput = ({ CTA, name, id, type, currentValue, Callback, defaultValue, disabled = false, specialCSS = null }) => {
    // console.log(id)
    if (type === 'file') {
        currentValue = null;
    }
    // console.log(currentValue)
    return (
        <div className="flex flex-col">
            <label htmlFor={name} className="block m-2 text-sm font-medium leading-6 text-gray-900">
                {CTA}
            </label>
            <input
                type={type}
                name={name}
                id={id}
                autoComplete="off"
                defaultValue={currentValue || defaultValue}
                onChange={(e) => {
                    e.preventDefault();
                    Callback(e);
                }}
                {...(type === 'file' ? { accept: 'image/*' } : {})}
                disabled={disabled}
                className={specialCSS || "block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"}
            />
        </div>
    )
}



const EditTest = () => {
    return (
        <div>
            <Navbar />
            <div className='sm:mx-[10vw] lg:mx-[15vw]'>
                <TestComponent />
            </div>
        </div>
    )
}

export default EditTest